module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-30-1ffaec23fc396192ca30678484ec2d70.svg";